import { forwardRef } from 'react'
import Styles from './Popover.module.scss'
import cx from 'classnames'

import { PopoverProps } from './Types'
import { useObjectRef } from 'utils/useObjectRef'
import { useOverlay } from '@react-aria/overlays'
import { FocusScope } from '@react-aria/focus'
import { FloatingOverlay } from '@floating-ui/react-dom-interactions'

const Popover = forwardRef<HTMLDivElement, PopoverProps>((props, fRef) => {
  const ref = useObjectRef(fRef)
  const { children, style, containFocus = true, autoFocus = true, restoreFocus = true, noOverlay } = props
  const { overlayProps } = useOverlay(props, ref)

  const renderContent = () => (
    <div
      {...(noOverlay ? {} : overlayProps)}
      ref={ref}
      className={cx(Styles.root, props.className)}
      style={style}
      data-theme={props['data-theme']}
    >
      {children}
    </div>
  )

  return (
    <FocusScope contain={containFocus} autoFocus={autoFocus} restoreFocus={restoreFocus}>
      {noOverlay ? (
        <div className={cx(Styles.backdrop, props.backdropClass)}>{renderContent()}</div>
      ) : (
        <FloatingOverlay
          className={cx(Styles.backdrop, props.backdropClass)}
          onContextMenu={(e) => {
            props.onClose()
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          {renderContent()}
        </FloatingOverlay>
      )}
    </FocusScope>
  )
})

export { Popover }
